import {Controller} from '@hotwired/stimulus';

/**
 * JS de la page "liste des offres"
 */
export default class extends Controller {
  static targets = ['montlyPrice', 'yearlyPrice'];
  static values = {
    priceType: String,
  };

  connect() {
    window.addEventListener('subscription--offerlist:price-type-changed', (event) => {
      this.priceTypeValue = event.detail.priceType;
    });
  }

  /**
   * Affiche le bon prix (mensuel ou annuel) en fonction du switch "au mois / à l'année"
   */
  priceTypeValueChanged(value, previousValue) {
    this.montlyPriceTarget.classList.toggle('d-none', value === 'yearly');
    this.yearlyPriceTarget.classList.toggle('d-none', value === 'monthly');
  }
}
